import { ListItemIcon, Menu, MenuItem } from '@mui/material'
import { DeleteOutlineOutlined, MoreVertOutlined } from '@mui/icons-material'

import { ReminderType } from '@tabeeb/enums'
import { ConfirmationDialog, useDialogState, usePopoverState } from '@collaborate-health/uikit'
import { FormAnswersDiscussion } from '@tabeeb/modules/shared/icons'

import { formTitleFormatter } from '@tabeeb/modules/shared/utils/text'
import { useDispatch, useSelector } from '@tabeeb/store'
import { openQuestionFormAnswersDialog } from '@tabeeb/modules/discussion/actions'
import Reminder from '@tabeeb/modules/reminders/components/Reminder'

import { clearFormAnswer } from '../../actions'
import { getFormById, getIsDeleteAnswerIconVisible } from '../../selectors'
import { FormControl, FormControlAnswer } from '../../types'

import { MenuIconButton } from './FormQuestionMenu.styles'

export interface FormQuestionMenuProps {
  control: FormControl
  answer?: FormControlAnswer | null
}

const FormQuestionMenu: React.FC<FormQuestionMenuProps> = ({ control, answer }) => {
  const dispatch = useDispatch()

  const [anchorRef, open, onOpen, onClose] = usePopoverState<HTMLButtonElement>()

  const [
    deleteAnswerConfirmationDialogOpen,
    onOpenDeleteAnswerConfirmationDialog,
    onCloseDeleteAnswerConfirmationDialog,
  ] = useDialogState()

  const form = useSelector((state) => getFormById(state, { Id: control.FormId }))
  const showDeleteOption = useSelector((state) => getIsDeleteAnswerIconVisible(state, { control }))

  const onOpenFormAnswersDialog = () => {
    dispatch(
      openQuestionFormAnswersDialog({
        question: {
          ...control,
          FormName: form?.Name,
          ContentFormId: form?.Id,
        },
      })
    )
  }

  return (
    <>
      <span>
        <MenuIconButton ref={anchorRef} shape='rectangular' size='small' onClick={onOpen}>
          <MoreVertOutlined />
        </MenuIconButton>
      </span>

      <Menu anchorEl={anchorRef.current} open={open} onClose={onClose}>
        <Reminder type={ReminderType.AnswerFormQuestion} entity={control} />

        <MenuItem
          onClick={() => {
            onClose()
            onOpenFormAnswersDialog()
          }}
        >
          <ListItemIcon>
            <FormAnswersDiscussion />
          </ListItemIcon>
          View answers
        </MenuItem>
        {showDeleteOption && (
          <MenuItem
            onClick={() => {
              onClose()
              onOpenDeleteAnswerConfirmationDialog()
            }}
          >
            <ListItemIcon>
              <DeleteOutlineOutlined color='error' />
            </ListItemIcon>
            Delete answer
          </MenuItem>
        )}
      </Menu>

      <ConfirmationDialog
        isOpen={deleteAnswerConfirmationDialogOpen}
        title='Are you sure you want to delete this answer?'
        dialogMessage={formTitleFormatter.format(`Form answer will be permanently deleted`)}
        submitButtonText='Delete'
        submitButtonColor='error'
        onCloseDialog={onCloseDeleteAnswerConfirmationDialog}
        onSubmit={() => {
          onCloseDeleteAnswerConfirmationDialog()
          dispatch(clearFormAnswer.request(answer?.Id!))
        }}
      />
    </>
  )
}

export default FormQuestionMenu

